import { c as _c } from "react/compiler-runtime";
import { DONE_CLEARING_MESSAGE, constructLeaveMessage, constructStartMessage } from 'indexed-db/messages';
import { useCallback, useEffect, useRef } from 'react';
function useIndexedDbWorker(path, id, messageHandler, onStart) {
  const $ = _c(11);
  const workerRef = useRef(null);
  let t0;
  if ($[0] !== id) {
    t0 = () => {
      const worker = workerRef.current;
      return new Promise(resolve => {
        ;
        try {
          if (!worker) {
            return resolve();
          }
          worker.addEventListener("message", ev => {
            if (ev.data !== DONE_CLEARING_MESSAGE) {
              return;
            }
            worker.terminate();
            workerRef.current = null;
            resolve();
          }, {
            once: true
          });
          worker.postMessage(constructLeaveMessage(id));
        } catch (t1) {
          const e = t1;
          reportError(e);
          resolve();
        }
      });
    };
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleLeave = t0;
  let t1;
  if ($[2] !== id || $[3] !== messageHandler || $[4] !== onStart || $[5] !== path) {
    t1 = () => {
      workerRef.current = new Worker(path, {
        type: "module"
      });
      const worker_0 = workerRef.current;
      worker_0.postMessage(constructStartMessage(id));
      worker_0.onmessage = messageHandler;
      onStart?.();
    };
    $[2] = id;
    $[3] = messageHandler;
    $[4] = onStart;
    $[5] = path;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleStart = t1;
  let t2;
  let t3;
  if ($[7] !== handleLeave || $[8] !== handleStart) {
    t2 = () => {
      handleStart();
      window.addEventListener("beforeunload", handleLeave);
      window.addEventListener("pageshow", handleStart);
      return () => {
        window.removeEventListener("beforeunload", handleLeave);
        handleLeave().then().catch();
      };
    };
    t3 = [handleLeave, handleStart];
    $[7] = handleLeave;
    $[8] = handleStart;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  return workerRef;
}
export default useIndexedDbWorker;